import React, { useEffect } from "react";
import OwlCarousel from "react-owl-carousel2";
import { useDispatch } from "react-redux";
import { modalActions } from "../../storage/modals";

const TopDonators = (props) => {
  const dispatch = useDispatch();
  
  useEffect(() => {
    if(props.content.description){
      dispatch(modalActions.setTopDonatorsDescriptionImg(props.content.description));
    }
  }, [props.content.description, dispatch])

  const options = {
    loop: false,
    items: 5,
    autoplay: false,
    mouseDrag: false,
    nav: false,
    margin: 30,
    responsive: {
      0: {
        items: 2,
        margin: 15,
      },
      576: {
        items: 3,
        margin: 15,
      },
      993: {
        items: 5,
        margin: 15,
      },
      1201: {
        items: 5,
        margin: 30,
      },
    },
  };

  const showDescriptionHandler = () => {
    dispatch(modalActions.showDonatorsModal());
  }

  return (
    <section className="top-donators">
      <div className="container">
        <div className="common-title">
          <h2 className="common-title__h2">
            Топ <span>донатеры</span> месяца
          </h2>
          <p className="common-title__subtitle">
            неоценимый вклад в развитие проекта
          </p>
        </div>
        <div className="top-donators-carousel">
          {props.content.donators.length > 0 && (
            <OwlCarousel
              options={options}
              className="top-donators-carousel-body owl-carousel"
            >
              {props.content.donators.map((element, index) => {
                return (
                  <div className="top-donator" key={index}>
                    <div className="top-donator__top">
                      <div className="top-donator-image">
                        <img
                          src={`/engine/3d.php?vr=10&hr=40&hrh=-50&vrla=0&vrra=-2&vrll=0&vrrl=2&ratio=12&format=png&displayHair=true&headOnly=false&user=${element.nick}`}
                          className="top-donator-image__src"
                          alt={"Топ донатер – " + element.nick}
                        />
                      </div>
                      <span className="top-donator-name">{element.nick}</span>
                      <span className="top-donator-place">
                        {index + 1}-ое место
                      </span>
                    </div>
                    <div className="top-donator__bottom">
                      <span className="top-donator-amount">
                        {element.sum} &#8381;
                      </span>
                      <span className="top-donator-label">
                        всего за этот месяц
                      </span>
                    </div>
                  </div>
                );
              })}
            </OwlCarousel>
          )}
        </div>
        <button type="button" className="cta-clear" onClick={showDescriptionHandler}>
          Что получают топ донатеры?
        </button>
      </div>
    </section>
  );
};

export default TopDonators;
